import styled from 'styled-components';
import { Text } from '../../../../components/Atoms/Text/Text';
import { media } from '../../../../theme/shared/breakpoints';
import { LazyImage } from '../../../components/LazyImage/LazyImage';
import { Gray } from '../../../constants/styles';
import { Hidden } from '../../../media/Hidden';
export const FooterSection = styled.section `
  width: 100%;
  background: #f5f5f5;
  border-top: 1px solid ${Gray.x200};
  margin-top: 20px;

  ${media.medium} {
    margin-top: 0;
  }
`;
export const FooterColumnHeading = styled(Text) `
  display: block;
  line-height: 34px;
`;
export const FooterWrapper = styled.footer `
  max-width: 1270px;
  margin: 0 auto;
  padding: 20px 20px 20px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;

  ${media.medium} {
    padding: 40px 20px 20px;
  }

  ${media.large} {
    padding: 50px 20px 10px;
  }
`;
export const FooterRow = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;
export const FooterRowRight = styled(FooterRow) `
  flex-basis: 100%;

  ${media.large} {
    justify-content: flex-end;
    margin-top: -80px;
  }
`;
export const FooterColumn = styled.div `
  flex-basis: 16.5%;
  pointer-events: auto;
`;
export const FooterColumnWide = styled(FooterColumn) `
  flex-basis: initial;

  ${media.large} {
    flex-basis: 34%;
  }
`;
export const FooterPayments = styled.div ``;
export const FooterPaymentsImage = styled(LazyImage) `
  max-width: 100%;
  max-height: 48px;
`;
export const FooterCopyrights = styled.div `
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  margin-top: 30px;
  border-top: 1px solid ${Gray.x200};
  flex-basis: 100%;

  p {
    color: ${({ theme }) => theme.colors.text03};
  }
`;
export const StyledMedia = styled(Hidden) `
  ${media.large} {
    display: flex;
    flex-direction: column;
    flex-basis: 16.5%;
    align-self: normal;
    justify-content: space-between;
  }
`;
//# sourceMappingURL=Footer.styled.js.map